// Incoming cheques section: shows expected income from incoming cheques.
import { Receipt } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const fmt = (n) => Math.round(Number(n || 0)).toLocaleString();

export function IncomingChequesSection({ items, ccy }) {
  const { lang } = useI18n();
  if (!items.length) return null;
  const total = items.reduce((s, c) => s + Number(c.amount || 0), 0);
  return (
    <section className="space-y-2 mb-4">
      <p className="text-xs font-bold text-emerald-600 uppercase tracking-widest flex items-center gap-2">
        <Receipt className="w-3.5 h-3.5" />
        {lang === "ar" ? "شيكات واردة (إيراد متوقع)" : "Incoming cheques (expected)"}
      </p>
      {items.map((c) => (
        <div key={c.id} data-testid={`obl-in-${c.id}`} className="p-2.5 rounded-xl neu-sm flex items-center gap-2.5">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold truncate">{c.drawer || c.payee}</p>
            <p className="text-xs text-slate-500">{c.due_date} · {c.bank_name || "—"}</p>
          </div>
          <span className="font-display font-extrabold text-sm tabular-nums text-emerald-600">+{fmt(c.amount)}</span>
        </div>
      ))}
      <p className="text-[10px] text-emerald-700 opacity-80 text-end">
        {lang === "ar" ? "لا تُخصم من الالتزامات" : "Not deducted from obligations"}: +{fmt(total)} {ccy}
      </p>
    </section>
  );
}
